import React from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Formik, Field } from 'formik';
import PropTypes from 'prop-types';
import * as yup from 'yup';

import { useNavigate } from 'react-router-dom';
import { HANDLE, HANDLE_REG_EXP, ID, UUID, UUID_REG_EXP } from '../../constants';

import FieldWrapper from '../form/wrappers/Field';

function HeaderSearchForm({ generateUrl, placeholder, htmlSize, type }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const onSubmit = (values) => navigate(generateUrl(values));
  let initialValues = {};
  let validationSchema = {};

  switch (type) {
    case UUID:
      initialValues = {
        uuid: '',
      };
      validationSchema = yup.object().shape({
        uuid: yup
          .string()
          .nullable()
          .matches(UUID_REG_EXP, { message: t('common:form.fields.uuid.error') }),
      });
      break;

    case HANDLE:
      initialValues = {
        handle: '',
      };
      validationSchema = yup.object().shape({
        handle: yup
          .string()
          .nullable()
          .matches(HANDLE_REG_EXP, {
            message: t('common:form.fields.handle.invalid'),
          })
          .max(100, t('common:form.errors.max', { count: 100 })),
      });
      break;

    case ID:
      initialValues = {
        id: null,
      };
      validationSchema = yup.object().shape({
        id: yup.number().typeError(t('common:form.errors.invalidNumber')).nullable(),
      });
      break;

    default:
      break;
  }

  return (
    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
      {({ handleSubmit, values }) => (
        <Form
          noValidate
          autoComplete="new-password"
          onSubmit={(e) => {
            e.preventDefault();
            if (!values[type]) return;
            handleSubmit();
          }}
        >
          <Field
            required
            className={`${type} mb-0`}
            htmlSize={htmlSize || 40}
            fieldClass="pe-0"
            id={`${type}SearchForm.${type}`}
            placeholder={placeholder || t(`common:form.fields.${type}.placeholder`)}
            name={type}
            component={FieldWrapper}
          />
        </Form>
      )}
    </Formik>
  );
}

HeaderSearchForm.propTypes = {
  /**
   * The url to which this form should navigate
   */
  generateUrl: PropTypes.func.isRequired,
};

export default HeaderSearchForm;
